import React from 'react'
import { Form, Button } from 'react-bootstrap'

const BidModalAmount = ({ inventoryCampaign, onChangeCpc, defaultValue, cpcInputValue, disableCPC, rate, currentCPC, onChangeCpcByButton }) => {
    return (
        <div className="text-center d-flex align-items-center justify-content-center" id="bid-modal-amount">
            <Form.Label htmlFor="blockCpc" className="dollar-sign" style={{ marginBottom: 0, width: 'max-content' }}>
                $
            </Form.Label>
            <div style={{ width: 'max-content' }}>
                <Form.Control
                    id="blockCpc"
                    placeholder={inventoryCampaign?.min_bid}
                    onChange={e => onChangeCpc(e)}
                    value={cpcInputValue !== null ? cpcInputValue : (currentCPC || '')}
                    disabled={disableCPC(inventoryCampaign)}
                    type="text"
                    className="cpc-field"
                    style={{ marginBottom: 0 }}
                />
                {rate && (cpcInputValue || currentCPC) && (
                    <div className="text-warning mb-1" id="rate-value">
                        {cpcInputValue ? `~ €${(cpcInputValue * rate).toFixed(2)}` : `~ €${(currentCPC * rate).toFixed(2)}`}
                    </div>
                )}
            </div>
            <Button
                variant="white"
                className="button-icon-button minus"
                disabled={disableCPC(inventoryCampaign)}
                onClick={() => onChangeCpcByButton('minus')}
                style={{ marginBottom: 10 }}
            >
                <i className="ri-indeterminate-circle-line button-icon"></i>
            </Button>
            <Button
                variant="white"
                className="button-icon-button plus"
                disabled={disableCPC(inventoryCampaign)}
                onClick={() => onChangeCpcByButton('plus')}
                style={{ marginBottom: 10 }}
            >
                <i className="ri-add-circle-line button-icon"></i>
            </Button>
        </div>
    )
}

export default BidModalAmount
